import { useEffect, useState } from 'react';
import { UseAsyncStateProps } from './useAsyncState.types';

const useAsyncState = ({ asyncFunction, defaultValue = null }: UseAsyncStateProps) => {
  const [payload, setPayload] = useState(defaultValue);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let ignore: boolean = false;
    (async () => {
      setLoading(true);
      setError(null);
      setPayload(defaultValue);

      try {
        const response = await asyncFunction();
        if (!ignore) setPayload(response);
      } catch (error) {
        if (!ignore) setError(error);
      } finally {
        if (!ignore) setLoading(false);
      }
    })();

    return () => {
      ignore = true;
    };
  }, [asyncFunction]);

  return [payload, loading, error];
};

export default useAsyncState;
